{ Button } = ReactComponents
ConfirmationModal = require 'components/common/confirmation_modal'
mediator = require 'mediator'
{ useState } = React
{ useCoffeeCallback, useI18n } = require 'lib/react_utils'

MdaHandoutExtraActions = ({ handoutId }) ->
  i18n = useI18n 'mda:handouts'
  [isModalOpen, setIsModalOpen] = useState false
  [isLoading, setIsLoading] = useState false

  onOpenModal = useCoffeeCallback [], ->
    setIsModalOpen true

  onCloseModal = useCoffeeCallback [], ->
    setIsModalOpen false
    setIsLoading false

  onConfirm = useCoffeeCallback [handoutId, onCloseModal, i18n], ->
    setIsLoading true
    mediator.services.aiService.generateHandoutContent handoutId
    .then ->
      mediator.dialogs.success i18n 'generate_ai.success'
    .catch (error) ->
      mediator.dialogs.error error?.message or i18n 'generate_ai.error'
    .finally ->
      onCloseModal()

  <div className="mda-handout-extra-actions">
    <Button onClick={onOpenModal}>
      {i18n 'generate_ai.button'}
    </Button>
    <ConfirmationModal
      cancelLabel={i18n '/actions.cancel'}
      confirmLabel={i18n 'generate_ai.confirmation_apply'}
      isOpen={isModalOpen}
      loading={isLoading}
      message={i18n 'generate_ai.confirmation_message'}
      onCancel={onCloseModal}
      onConfirm={onConfirm}
      question={i18n 'generate_ai.confirmation_question'}
      title={i18n 'generate_ai.confirmation_title'}
    />
  </div>

MdaHandoutExtraActions.propTypes =
  handoutId: PropTypes.string.isRequired

module.exports = MdaHandoutExtraActions
